import { Skeleton } from '@packages/shared/src/components/Skeleton/Skeleton';

export const WishlistSkeleton: React.FC = () => (
  <div data-testid="wishlist-skeleton">
    <Skeleton height="400px" variant="rounded" />
  </div>
);
